import React, { useState, useEffect} from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Accessibility from "@material-ui/icons/Accessibility";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
// core components
import GridItem from "../grid/GridItem";
import GridContainer from "../grid/GridContainer.js";

import Card from "../Card/Card.js";
import CardHeader from "../Card/CardHeader.js";
import CardBody from "../Card/CardBody.js";
import CardFooter from "../Card/CardFooter.js";
import './style.css'

import {
   chartObject
} from "./Variables";

import styles from "./ChartStyle";

const useStyles = makeStyles(styles);

const TimeChart = (props) => {
  const classes = useStyles();
  const { data, color, title, cases, diff } = props;
  const [history, setHistory] = useState({labels: [""], series:[[0]]});
  const [options, setOptions] =  useState(chartObject.options)
  const [percent, setPercent] = useState(0);
  
  useEffect(() => {
  const historyDates = Object.keys(data);
  const historyValues = Object.values(data);
  const opt = JSON.parse(JSON.stringify(chartObject.options));
  opt.high = Math.max(...historyValues);
   
    if(cases){
      const perc = (diff/cases)*100
      setPercent(perc.toFixed(2))
    }
   
   setOptions(opt);
  setHistory({ 
     labels: historyDates,
     series: [historyValues]
   })
  
  }, [data,cases,diff]);


  return (
      
        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color={color}>
              <ChartistGraph
                className="ct-chart"
                data={history}
                type="Line"
                options={options}
                listener={chartObject.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>{title} Cases</h4>
              <p className={classes.cardCategory}>
                <span className={color == "success" ? classes.successText : color=="gray" ? classes.grayText : classes.dangerText}>
                  <ArrowUpward className={classes.upArrowCardCategory} /> {cases && percent+"%"} 
                </span>{" "}
                {cases && "of infected cases"}
                {!cases && "Graph for all infected cases"}
              </p> 
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> updated few minutes ago
              </div>
            </CardFooter>
          </Card>
        </GridItem>
          
  );
}


export default TimeChart;